// extracted by mini-css-extract-plugin
export default {"copyToClipboard":"CopyToClipboard_copyToClipboard__msU2f","tooltip":"CopyToClipboard_tooltip__NVUX-","message":"CopyToClipboard_message__IsBNo"};